import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-width" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "normal-size" }
const _hoisted_5 = { class: "normal-size" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]

import mediaGallery from "../media-gallery/MediaGalleryMain.vue";
import specs from "./specs.vue";
import usp from "../../../content/usp/usp.vue";
import VideoViewer from "../common/video-link/video-viewer.vue";
import brandInfo from "../shop/brand-info.vue";
// import relatedProducts from "./related-products.vue";
// import SpoergEksperterne from "./spoerg-eksperterne.vue";
import { computed, ref, type PropType } from "vue";
import { type Setup, type AuctionProduct, type PhoneValidation } from "./types";
import labels from "../../shared/labels";
import { registerVueProductSpec } from "../../../../utilities/spec-updater/registerVueProductSpec";
import { registerVueProductCountdown } from "../../../../utilities/countdown";
import { format } from "../../../../shared/utils/string";
import { getCheapestFreightMethod } from "../product-specs/delivery-info";
import { createCurrencyFormatter } from "../common/amount-format";
import RelatedProducts from "./related-products.vue";
import SoldOverlay from "./sold-overlay.vue";
import StayInclusionInfoBox from "./StayInclusionInfoBox.vue";
import RedeemInfoBox from "./RedeemInfoBox.vue";
import ProductImageOverlays from "../common/product-image-overlays.vue";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";
import { type OverwriteSettings } from "../../../commons/product/overwrite-settings";
import fallbackImage from "../fallback-image.jpg?file";
import { type MediaItem } from "../media-gallery/types";

export default /*@__PURE__*/_defineComponent({
  __name: 'auction-product',
  props: {
    product: {
        type: Object as PropType<AuctionProduct>,
        required: true,
    },
    setup: {
        type: Object as PropType<Setup>,
        required: true,
    },
    overwriteSettings: Object as PropType<OverwriteSettings>,
    phoneValidation: Object as PropType<PhoneValidation>,
},
  setup(__props) {

const formatter = createCurrencyFormatter();
function formatAmount(value: number) {
    return formatter.format(value);
}

const props = __props;

const breakpointObserver = getBreakpointObservable();

const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});
const verticalMediaGallery = computed(() => {
    return currentBreakpoint.value?.up("lg") ?? false;
});
const productHasStayInformation = computed(() => {
    return (
        props.product.experienceInformation != null &&
        props.product.experienceInformation.stayInclusions.length > 0
    );
});

const initializedDate = ref<Date>();
const initialSeconds = ref<number>();

const cheapestMethod = computed(() => {
    let label = labels.frontendProductpage.specs.deliveryLabel;
    if (typeof label !== "string") return undefined;
    if (label.endsWith(":")) {
        label = label.substring(0, label.length - 1);
    }

    const cheapest = getCheapestFreightMethod(
        props.product.methods.filter((x) => x.isPickupMethod == false)
    );
    if (cheapest == null) {
        const deliveryItem = props.product.methods.find(
            (x) => x.deliveryChoice == "Delivery"
        );
        if (deliveryItem != null) {
            return {
                text: label,
                price: formatAmount(deliveryItem.price),
            };
        }
        return undefined;
    }

    const item = {
        text: label,
        price:
            props.product.methods.filter(
                (m) => m.deliveryChoice === "FreightMethod"
            ).length == 1
                ? formatAmount(cheapest.price)
                : (
                      labels.frontendProductpage.specs
                          .deliveryStartingPrice as string
                  ).replace(/\{0\}/g, formatAmount(cheapest.price)),
    };

    return item;
});

const pickupItem = computed(() => {
    const pickupMethod = props.product.methods.find(
        (x) => x.isPickupMethod || x.deliveryChoice == "Pickup"
    );
    if (
        pickupMethod == null ||
        pickupMethod.specLabel == null ||
        pickupMethod.specHint == null
    )
        return undefined;
    return pickupMethod.specLabel + " " + pickupMethod.specHint;
});

const media = computed(() => {
    if (props.product.media != null && props.product.media.length > 0)
        return props.product.media;
    const res: MediaItem[] = [
        {
            src: fallbackImage,
            alt: "Billede mangler",
            type: "picture",
            size: {
                width: 470,
                height: 353,
            },
            sources: [],
            srcset: "",
            thumbnail: fallbackImage,
        },
    ];
    return res;
});

registerVueProductSpec({
    productId: props.product.id,
    secondsLeftGetter: () => props.product.timeTotalSeconds,
    callbackUpdatedItem(item) {
        initializedDate.value = undefined;
        initialSeconds.value = undefined;

        props.product.timeIsNotStarted = item.timeIsNotStarted;
        props.product.timeTotalSeconds = item.timeTotalSeconds;
        if (item.isAuction) {
            props.product.currentBid = item.price;
            props.product.estimatedPrice = item.value;
            props.product.showEstimatedPrice =
                item.value != null && item.value > 0;
            props.product.winningBid =
                item.currentBidOwner != null
                    ? {
                          name: item.currentBidOwner,
                          currentUser: item.currentBidIsCurrentUser === true,
                          maxBid: item.currentUserMaxBid,
                      }
                    : undefined;
            props.product.hasBidOnProduct =
                item.currentUserHasBidOnProduct === true;
            props.product.bidders = item.bidders ?? 0;
        }
    },
});

registerVueProductCountdown({
    itemId: props.product.id,
    secondsGetter: () => props.product.timeTotalSeconds,
    secondsSetter: (v) => {
        props.product.timeTotalSeconds = v;
    },
    getInitializedDate: () => initializedDate.value,
    getInitialSeconds: () => initialSeconds.value,
    setInitializedDate: (v) => (initializedDate.value = v),
    setInitialSeconds: (v) => (initialSeconds.value = v),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['product-page'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", {
        class: _normalizeClass(_ctx.$style['product-title'])
      }, _toDisplayString(__props.product.name), 3 /* TEXT, CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['product-content'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['media-gallery-container'])
        }, [
          _createVNode(mediaGallery, {
            value: media.value,
            "full-width": !verticalMediaGallery.value,
            vertical: verticalMediaGallery.value
          }, _createSlots({
            "after-first-image": _withCtx(() => [
              _createVNode(ProductImageOverlays, { product: __props.product }, null, 8 /* PROPS */, ["product"])
            ]),
            _: 2 /* DYNAMIC */
          }, [
            (__props.product.bidIsPaid)
              ? {
                  name: "inside-frame",
                  fn: _withCtx(() => [
                    _createVNode(SoldOverlay, {
                      class: _normalizeClass(_ctx.$style['sold-overlay'])
                    }, null, 8 /* PROPS */, ["class"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "full-width", "vertical"]),
          (
                            productHasStayInformation.value &&
                            currentBreakpoint.value?.up('lg') == true
                        )
            ? (_openBlock(), _createBlock(StayInclusionInfoBox, {
                key: 0,
                product: __props.product,
                class: _normalizeClass(_ctx.$style['stay-inclusion-lg'])
              }, null, 8 /* PROPS */, ["product", "class"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style['description-lg']])
          }, [
            _createElementVNode("div", {
              innerHTML: __props.product.description,
              class: _normalizeClass([_ctx.$style['product-description']])
            }, null, 10 /* CLASS, PROPS */, _hoisted_2),
            (__props.product.videoLink != null)
              ? (_openBlock(), _createBlock(VideoViewer, {
                  key: 0,
                  class: _normalizeClass([_ctx.$style['video-viewer']]),
                  "video-link": __props.product.videoLink
                }, null, 8 /* PROPS */, ["class", "video-link"]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['specs-container'])
        }, [
          _createVNode(specs, {
            product: __props.product,
            setup: __props.setup,
            "phone-validation": __props.phoneValidation,
            "overwrite-settings": __props.overwriteSettings
          }, null, 8 /* PROPS */, ["product", "setup", "phone-validation", "overwrite-settings"]),
          (
                            (__props.product.hasServiceFee &&
                                __props.product.serviceFeePercent != null) ||
                            (!__props.product.hideFreightMethods &&
                                cheapestMethod.value != null) ||
                            pickupItem.value != null ||
                            __props.product.canBeParked
                        )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.$style['delivery-and-info'])
              }, [
                (
                                __props.product.hasServiceFee &&
                                __props.product.serviceFeePercent != null
                            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_unref(format)(
                                    _unref(labels).frontendProductpage.serviceFeeInfo,
                                    __props.product.serviceFeePercent
                                )) + " ", 1 /* TEXT */),
                      _createElementVNode("span", {
                        class: _normalizeClass([
                                    'tooltip-hint popup-text gray small',
                                    _ctx.$style['tooltip-service-fee'],
                                ])
                      }, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(labels).frontendProductpage
                                            .serviceFeeAbout), 1 /* TEXT */)
                      ], 2 /* CLASS */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (__props.product.canBeParked)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(_ctx.$style['can-be-parked-text'])
                    }, [
                      _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage[
                                    __props.product.canBeParked_sponsor
                                        ? "canBeParked_sponsor"
                                        : "canBeParked"
                                ]) + " ", 1 /* TEXT */),
                      _createElementVNode("span", {
                        class: _normalizeClass([
                                    'tooltip-hint popup-text gray small',
                                    _ctx.$style['tooltip-can-be-parked'],
                                ])
                      }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(labels).frontendProductpage[
                                            __props.product.canBeParked_sponsor
                                                ? "canBeParkedAbout_sponsor"
                                                : "canBeParkedAbout"
                                        ]), 1 /* TEXT */)
                      ], 2 /* CLASS */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                (
                                (!__props.product.hideFreightMethods &&
                                    cheapestMethod.value != null) ||
                                pickupItem.value != null
                            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style['delivery-header'])
                      }, [
                        _createElementVNode("strong", null, [
                          (
                                            pickupItem.value != null &&
                                            cheapestMethod.value != null
                                        )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage
                                                .deliveryInfoHeader_deliveryAndPickup), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : (
                                            pickupItem.value != null &&
                                            cheapestMethod.value == null
                                        )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage
                                                .deliveryInfoHeader_pickup), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (
                                            pickupItem.value == null &&
                                            cheapestMethod.value != null
                                        )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage
                                                .deliveryInfoHeader_delivery), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage
                                            .deliveryInfoHeader), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                        ])
                      ], 2 /* CLASS */),
                      (
                                    !__props.product.hideFreightMethods &&
                                    cheapestMethod.value != null
                                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(cheapestMethod.value.text) + " " + _toDisplayString(cheapestMethod.value.price.toLowerCase()), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (pickupItem.value != null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(pickupItem.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (__props.product.cause != null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.$style['cause-info'])
              }, [
                _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.forCause) + " ", 1 /* TEXT */),
                _createElementVNode("strong", null, _toDisplayString(__props.product.cause.name), 1 /* TEXT */),
                (
                                __props.product.cause.showMoreLabel != null &&
                                __props.product.cause.showMoreLink != null
                            )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                      _createElementVNode("a", {
                        href: __props.product.cause.showMoreLink,
                        class: _normalizeClass(_ctx.$style['show-more-link'])
                      }, _toDisplayString(__props.product.cause.showMoreLabel), 11 /* TEXT, CLASS, PROPS */, _hoisted_9)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (__props.product.sponsor != null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(_ctx.$style['sponsor-info'])
              }, [
                _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.donatedBy) + " ", 1 /* TEXT */),
                _createElementVNode("strong", null, _toDisplayString(__props.product.sponsor.name), 1 /* TEXT */),
                (
                                __props.product.sponsor.showMoreLabel != null &&
                                __props.product.sponsor.showMoreLink != null
                            )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                      _createElementVNode("a", {
                        href: __props.product.sponsor.showMoreLink,
                        class: _normalizeClass(_ctx.$style['show-more-link'])
                      }, _toDisplayString(__props.product.sponsor.showMoreLabel), 11 /* TEXT, CLASS, PROPS */, _hoisted_10)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (
                            productHasStayInformation.value &&
                            !(currentBreakpoint.value?.up('lg') == true)
                        )
            ? (_openBlock(), _createBlock(StayInclusionInfoBox, {
                key: 3,
                product: __props.product,
                class: _normalizeClass(_ctx.$style['stay-inclusion-lg'])
              }, null, 8 /* PROPS */, ["product", "class"]))
            : _createCommentVNode("v-if", true),
          (
                            !__props.product.isStockProduct || __props.product.forceRedeemInfo
                        )
            ? (_openBlock(), _createBlock(RedeemInfoBox, {
                key: 4,
                class: _normalizeClass(_ctx.$style['redeem-info-box']),
                product: __props.product
              }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                (__props.product.thirdPartyWarning != null)
                  ? {
                      name: "after-items",
                      fn: _withCtx(() => [
                        _createElementVNode("li", {
                          innerHTML: __props.product.thirdPartyWarning
                        }, null, 8 /* PROPS */, _hoisted_11)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "product"]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ]),
    _createCommentVNode(" <div\r\n            :class=\"[$style['mobile-wrapper-spoerg-eksp'], 'content-width']\"\r\n            v-if=\"product.isStockProduct === true\"\r\n        >\r\n            <spoerg-eksperterne></spoerg-eksperterne>\r\n        </div> "),
    _createCommentVNode(" <div\r\n            v-if=\"productHasStayInformation\"\r\n            :class=\"['content-width', $style['product-info-boxes']]\"\r\n        >\r\n            <RedeemInfoBox :product=\"product\" />\r\n        </div> "),
    _createElementVNode("div", {
      class: _normalizeClass(['content-width', _ctx.$style['description-sm']])
    }, [
      _createElementVNode("div", {
        innerHTML: __props.product.description,
        class: _normalizeClass([_ctx.$style['product-description']])
      }, null, 10 /* CLASS, PROPS */, _hoisted_12),
      (__props.product.videoLink != null)
        ? (_openBlock(), _createBlock(VideoViewer, {
            key: 0,
            class: _normalizeClass([_ctx.$style['video-viewer']]),
            "video-link": __props.product.videoLink
          }, null, 8 /* PROPS */, ["class", "video-link"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (__props.product.isStockProduct === true)
      ? (_openBlock(), _createBlock(usp, {
          key: 0,
          auction: ""
        }))
      : _createCommentVNode("v-if", true),
    (__props.product.brandInfo != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['content-width', _ctx.$style['brand-info-comp']])
        }, [
          _createVNode(brandInfo, {
            "brand-info": __props.product.brandInfo
          }, null, 8 /* PROPS */, ["brand-info"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(['content-width', _ctx.$style['related-info']])
    }, [
      _createVNode(RelatedProducts, { product: __props.product }, null, 8 /* PROPS */, ["product"])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})